import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {ClipboardModule} from "ngx-clipboard";
import {HighchartsChartModule} from 'highcharts-angular';
import {NamedRoutesService} from "ng-named-routes";
import {ContentControllerService} from "./content-controller.service";
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {HeaderComponent} from './header/header.component';
import {DeploymentsViewComponent} from './deployments-view/deployments-view.component';
import {MomentModule} from "ngx-moment";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GliderMapComponent} from './glider-map/glider-map.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {FooterComponent} from './footer/footer.component';
import {DataComponent} from './data/data.component';
import {DataDownloadComponent} from './data-download/data-download.component';
import {DataPlotComponent} from './data-plot/data-plot.component';
import {DataPlotInteractiveComponent} from './data-plot-interactive/data-plot-interactive.component';
import {DeploymentsAllComponent} from './deployments-all/deployments-all.component';
import {DeploymentsComponent} from './deployments/deployments.component';
import {EquipmentComponent} from './equipment/equipment.component';
import {EquipmentGlidersComponent} from './equipment-gliders/equipment-gliders.component';
import {EquipmentInstrumentsComponent} from './equipment-instruments/equipment-instruments.component';
import {AboutComponent} from './about/about.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {ContactComponent} from './contact/contact.component';
import {PartnersComponent} from './partners/partners.component';
import {TcComponent} from './tc/tc.component';
import {DeploymentsMissionComponent} from './deployments-mission/deployments-mission.component';
import {NgxSpinnerModule} from "ngx-spinner";
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {RouterModule} from '@angular/router';
import {IconsModule} from "./icons/icons.module";
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {DevComponent} from './dev/dev.component';
import {LinkNameDirective} from './link-name.directive';
import {GetRoutePipe} from './get-route.pipe';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PlotlyViaWindowModule} from 'angular-plotly.js';
import {HighchartsChartComponent} from 'highcharts-angular';
//import {ZingchartAngularModule} from "zingchart-angular";
import {DeploymentsMonitoringComponent } from './deployments-monitoring/deployments-monitoring.component';
import {DevDataStatusComponent} from './dev-data-status/dev-data-status.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        DeploymentsViewComponent,
        GliderMapComponent,
        FooterComponent,
        DataComponent,
        DataDownloadComponent,
        DataPlotComponent,
        DataPlotInteractiveComponent,
        DeploymentsComponent,
        DeploymentsAllComponent,
        EquipmentComponent,
        EquipmentGlidersComponent,
        EquipmentInstrumentsComponent,
        AboutComponent,
        AboutUsComponent,
        ContactComponent,
        PartnersComponent,
        TcComponent,
        DeploymentsMissionComponent,
        DevComponent,
        LinkNameDirective,
        GetRoutePipe,
        DeploymentsMonitoringComponent,
        DevDataStatusComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        RouterModule,
        HttpClientModule,
        MomentModule,
        FormsModule,
        ReactiveFormsModule,
        ClipboardModule,
        HighchartsChartModule,
        NgxSpinnerModule,
        FontAwesomeModule,
        LeafletModule,
        IconsModule,
        TooltipModule.forRoot(),
        PlotlyViaWindowModule,
        //ZingchartAngularModule
    ],
    providers: [NamedRoutesService, ContentControllerService],
    bootstrap: [AppComponent]
})
export class AppModule {

}
